(() => {
  if (window.sylavieSustainabilityControllerLoaded) return;

  window.sylavieSustainabilityControllerLoaded = true;

  const SECTION_SELECTOR = '[data-sustainability]';
  const REVEAL_SELECTOR = '[data-sustainability-reveal]';
  const CARD_SELECTOR = '.sustainability__point';
  const VISIBLE_CLASS = 'is-visible';
  const INITIALIZED_CLASS = 'is-initialized';
  const CARD_STAGGER = 70;
  const instances = new WeakMap();

  class SustainabilitySection {
    constructor(section) {
      this.section = section;
      this.items = Array.from(section.querySelectorAll(REVEAL_SELECTOR));
      this.cards = Array.from(section.querySelectorAll(CARD_SELECTOR));
      this.observer = null;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => this.refresh();

      this.reduceMotion.addEventListener('change', this.onMotionChange);
      this.setCardStagger();
      this.refresh();
    }

    setCardStagger() {
      this.cards.forEach((card, index) => {
        card.style.setProperty('--sustainability-reveal-delay', `${index * CARD_STAGGER}ms`);
      });
    }

    refresh() {
      this.disconnect();

      if (this.reduceMotion.matches || !('IntersectionObserver' in window)) {
        this.section.classList.remove(INITIALIZED_CLASS);
        this.items.forEach((item) => item.classList.add(VISIBLE_CLASS));
        return;
      }

      this.section.classList.add(INITIALIZED_CLASS);
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add(VISIBLE_CLASS);
            this.observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -5% 0px',
          threshold: 0.08,
        }
      );

      this.items.forEach((item) => this.observer.observe(item));
    }

    disconnect() {
      if (!this.observer) return;

      this.observer.disconnect();
      this.observer = null;
    }

    destroy() {
      this.disconnect();
      this.reduceMotion.removeEventListener('change', this.onMotionChange);
      this.section.classList.remove(INITIALIZED_CLASS);
    }
  }

  const getSections = (root = document) => {
    if (root.matches?.(SECTION_SELECTOR)) return [root];

    return Array.from(root.querySelectorAll(SECTION_SELECTOR));
  };

  const initSections = (root = document) => {
    getSections(root).forEach((section) => {
      const existing = instances.get(section);
      if (existing) existing.destroy();

      instances.set(section, new SustainabilitySection(section));
    });
  };

  const destroySections = (root) => {
    getSections(root).forEach((section) => {
      const instance = instances.get(section);
      if (!instance) return;

      instance.destroy();
      instances.delete(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSections());
  } else {
    initSections();
  }

  document.addEventListener('shopify:section:load', (event) => initSections(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroySections(event.target));
})();
